<template>
  <footer class="footer">
    <div class="footer-modules container">
      <div class="show-subscribe">
        <h3>Subscribe to the show</h3>
        <div v-if="socialLinks">
          <a v-for="(link, i) in socialLinks" :key="i" target="_blank" :href="link.url" rel="noopener noreferrer">
            <span class="icon" :class="`${link.name.toLowerCase().replace(/ /g, '-')}`">
              <iconify-icon :icon="link.icon"></iconify-icon>
            </span>
            <span class="sr-only">{{ link.name }}</span>
          </a>
        </div>
      </div>
      <div class="newsletter-subscribe" id="newsletter">
        <h3>Sign up for the newsletter</h3>
        <div class="newsletter-form-container">
          <iframe src="https://longestshortesttime.substack.com/embed" width="480" height="160" frameborder="0"
            scrolling="no" style="display: block;"></iframe>
        </div>
      </div>
    </div>
    <div class="site-info container">
      <router-link :to="{ name: 'Home' }" tag="h4" v-if="!isHome">The Longest Shortest Time</router-link>
      <h4 v-else @click="scrollToTop()">The Longest Shortest Time</h4>
      <nav>
        <div class="nav-center nav-menu">
          <router-link :to="{ name: 'Episodes' }" class="nav-item">
            <span>Stories</span>
          </router-link>
          <router-link :to="{ name: 'About' }" class="nav-item">
            <span>About</span>
          </router-link>
          <a class="nav-item" href="https://longestshortesttime.supportingcast.fm/" target="_blank"
            rel="noopener noreferrer">
            <span>Join the Club</span>
          </a>
          <a class="nav-item" href="https://the-longest-shortest-time.myshopify.com/" target="_blank"
            rel="noopener noreferrer">
            <span>Shop</span>
          </a>
        </div>
        <div class="nav-center nav-menu secondary-nav">
          <a href="/terms" class="nav-item"><span>Terms of Service</span></a>
          <a href="/privacy" class="nav-item"><span>Privacy Policy</span></a>
          <a href="/cookie-policy" class="nav-item"><span>Cookie Policy</span></a>
          <a href="javascript:UC_UI.showSecondLayer();" id="usercentrics-psl" class="nav-item"><span>Privacy
              Settings</span></a>
        </div>
      </nav>
      <p class="text-center">&copy;2010-{{ currentYear }} The Longest Shortest Time LLC</p>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'site-footer',
  data() {
    return {
      currentYear: new Date().getFullYear(),
      email: '',
      firstName: '',
      lastName: '',
      success: false,
      error: null,
      socialLinks: [
        {
          name: 'Apple Podcasts',
          icon: 'ph:apple-podcasts-logo-fill',
          url: 'https://podcasts.apple.com/us/podcast/the-longest-shortest-time/id412457621?mt=2'
        },
        {
          name: 'Spotify',
          icon: 'mdi:spotify',
          url: 'https://open.spotify.com/show/7sfcXmCcDIsdd1uvYOIQGp?si=dadbc012c74446b2'
        },
        {
          name: 'RSS',
          icon: 'material-symbols:rss-feed',
          url: 'https://feeds.megaphone.fm/QCD4231325211'
        }
      ]
    }
  },
  beforeMount() {
    if (sessionStorage.getItem('newsletterSubscribe')) {
      this.success = true
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    submit() {
      let vm = this
      // POST /subscribe => newsletter_subscribe() [theme-folder]/api/functions.php
      vm.$axios.post('/subscribe', {
        email: vm.email,
        first_name: vm.firstName,
        last_name: vm.lastName
      })
        .then((response) => {
          if (response.data.success) {
            vm.email = ''
            vm.lastName = ''
            vm.firstName = ''
            vm.success = true
            vm.error = null
            sessionStorage.setItem('newsletterSubscribe', true)
          } else {
            vm.error = response.data.data.message
          }
        })
    }
  },
  computed: {
    ...mapGetters([
      'socialLinks'
    ]),
    isHome() {
      return this.$route.name === 'Home'
    }
  }
}
</script>

<style lang="sass" scoped>
@import ../../assets/styles/colors
@import ../../assets/styles/mixins
.footer
  padding-top: 56px
  background-color: $turquoise
  h5
    font-size: 1.75rem
    line-height: 1.25
    text-align: center
  h4
    font-size: 2.25rem
    width: 225px
    margin: auto
    text-align: center
    font-weight: bold
    line-height: 1.1
    cursor: pointer
    &:hover
      color: #fff
  .social-nav
    margin: 30px 0 60px
    a
      color: inherit
      padding: 20px
      .fa
        font-size: 36px
    +smDesktop
      display: none
  .nav-menu
    margin-top: 36px
    &.secondary-nav
      margin-top: 0
      margin-bottom: 0
      a
        font-size: 1.25rem
        line-height: 1
    +until($tablet)
      margin-bottom: 0
      flex-wrap: wrap
      span
        display: block
        width: 100%
        text-align: center
    +tablet
      margin-bottom: 0
      width: 490px
      /*justify-content: space-between*/
      &.secondary-nav
        margin-bottom: 66px
    .nav-item
      font-size: 1.45rem
      color: $textColor
      +tablet
        font-size: 1.6rem
      &:hover
        text-decoration: underline
  p
    font-size: 13px
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif
    +tablet
      font-size: 14px

.footer-modules
  margin-bottom: 3rem
  +desktop
    display: flex
    justify-content: space-between
    margin-bottom: 6rem
  > div
    flex: 1
    background: rgba(255,255,255,0.25)
    padding: 20px
    +tablet
      padding: 32px 64px
    h3
      font-size: 24px
      line-height: 1.2
      letter-spacing: 0.25px
      text-align: center
      font-weight: bold
      margin-bottom: 16px
      +tablet
        font-size: 30px
        line-height: 46px
    &:first-child
      +desktop
        margin-right: 40px
    &.show-subscribe
      > div
        display: flex
        justify-content: center
        +desktop
          justify-content: space-between
        a
          display: flex
          background: #fff
          align-items: center
          justify-content: center
          color: #919191
          border-radius: 50%
          padding: 10px
          width: 48px
          height: 48px
          margin: 0 10px
          &:hover
            background: #eee
          +lgPhone
            width: 64px
            height: 64px
            padding: 15px
          +tablet
            width: 92px
            height: 92px
          +desktop
            margin: 0
          .icon
            width: auto
            height: auto
            font-size: 26px
            +lgPhone
              font-size: 36px
            +tablet
              font-size: 64px
              &.rss
                font-size: 54px
                position: relative
                left: 3px
                bottom: 2px
    &.newsletter-subscribe
      .form
        margin: auto
        position: relative
        +tablet
          width: 360px
        .is-grouped
          +until($tablet)
            display: block
            .control:first-child
              margin-right: 0
              margin-bottom: 0.75rem
        input
          width: 100%
          border: 0
          height: 48px
          padding: 15px 26px
          border-radius: 50px
          font-size: 1.1rem
          box-sizing: border-box
        button
          background: transparent
          margin-left: auto
          margin-right: 0
          display: block
          padding: 0
          +tablet
            position: absolute
            bottom: -2px
            right: -60px
          span
            opacity: 0
            position: absolute

.newsletter-form-container
  border-radius: 20px
  overflow: hidden            
</style>



// WEBPACK FOOTER //
// SiteFooter.vue?1a1f1889